import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { invalidarSugestoes } from "@/hooks/useSugestoes";

// Lote 117 — mapa leve "dígitos do CNJ -> processo monitorado" para os atalhos "abrir em Processos".
// Uma só consulta compartilhada por toda a tela (cache de 60 s); `invalidarProcessosMapa()` depois de cadastrar.
const cache = { map: null, ts: 0, promise: null };

export const soDigitos = (t) => String(t || "").replace(/\D/g, "");

export function invalidarProcessosMapa() {
  cache.ts = 0;
  invalidarSugestoes();
}

export default function useProcessosMapa() {
  const [mapa, setMapa] = useState(cache.map);
  useEffect(() => {
    let vivo = true;
    if (cache.map && Date.now() - cache.ts < 60000) { setMapa(cache.map); return () => {}; }
    if (!cache.promise) {
      cache.promise = http.get("/processos-numeros")
        .then((r) => {
          const lista = Array.isArray(r.data) ? r.data : [];
          // Lote 118: um número pode ter vários autos — o mapa guarda o 1º (Principal) e a lista completa em `todos`.
          const m = new Map();
          lista.forEach((x) => {
            const cur = m.get(x.digits);
            if (!cur) m.set(x.digits, { ...x, todos: [x] });
            else cur.todos.push(x);
          });
          cache.map = m;
          cache.ts = Date.now();
          return cache.map;
        })
        .catch(() => cache.map || new Map())
        .finally(() => { cache.promise = null; });
    }
    cache.promise.then((m) => { if (vivo) setMapa(m); });
    return () => { vivo = false; };
  }, []);
  return mapa;
}
